import type { ObjectId } from '@freightview/object-id'

import {
  vObject,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export interface LoadNote {
  _id: ObjectId
  source: NoteSource
  type: NoteType
  createdDate: Date
  createdBy?: NoteCreatedBy
  message: string
}

interface NoteCreatedBy {
  userId?: string
  name?: string
  ipAddress?: string
}

export const noteSources = [
  'shipper',
  'carrier',
  'system',
  'anonymous',
] as const
export type NoteSource = (typeof noteSources)[number]
export const noteTypes = ['general', 'audit', 'internal'] as const
export type NoteType = (typeof noteTypes)[number]

export const createLoadNoteSchema = vObject({
  source: vPicklist(noteSources),
  type: vPicklist(noteTypes),
  message: vString(),
})

export type CreateLoadNoteDTO = vOutput<typeof createLoadNoteSchema>
